import React from 'react';
import { AnimatePresence } from 'framer-motion';

import '@fontsource/anton';
import '@fontsource/open-sans';
import '@fontsource/roboto-condensed';

import './src/styles/main.css';
import './src/styles/navbar.css';
import './src/styles/footer.css';
import './src/styles/scroll-top.css';
import type { WrapPageElementBrowserArgs } from 'gatsby';

export function wrapPageElement({ element }: WrapPageElementBrowserArgs) {
	return <AnimatePresence exitBeforeEnter>{element}</AnimatePresence>;
}

export const onRouteUpdate = ({ location, prevLocation }) => {
	if (location && location.state)
		location.state.referrer = prevLocation ? prevLocation.pathname : null;
};

export const onClientEntry = () => {
	// IntersectionObserver polyfill for gatsby-background-image (Safari, IE)
	if (!(`IntersectionObserver` in window)) {
		import(`intersection-observer`);
		if (process.env.NODE_ENV !== 'production') {
			console.log(`# IntersectionObserver is polyfilled!`);
		}
	}
};
